'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BizMgrProviderApi = function () {
  function BizMgrProviderApi(viewMode, locale, baseUrl) {
    var instance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    (0, _classCallCheck3.default)(this, BizMgrProviderApi);

    this.viewMode = viewMode;
    this.locale = locale;
    this.baseUrl = baseUrl;
    this.instance = instance;
  }

  (0, _createClass3.default)(BizMgrProviderApi, [{
    key: 'getDecodedInstanceObject',
    value: function getDecodedInstanceObject() {
      var instanceObject = {};

      try {
        var instanceStr = this.instance;
        var encodedInstance = instanceStr.substring(instanceStr.indexOf('.') + 1);
        instanceObject = JSON.parse(this.decodeBase64(encodedInstance));
      } catch (error) {
        console.error('BizMgrProviderApi - error getting instance object', error);
      }

      return instanceObject;
    }
  }, {
    key: 'decodeBase64',
    value: function decodeBase64(str) {
      return atob(str);
    }
  }, {
    key: 'getAnonymousUserId',
    value: function getAnonymousUserId() {
      // Used only in live site
      return '';
    }
  }, {
    key: 'getViewMode',
    value: function getViewMode() {
      return this.viewMode;
    }
  }, {
    key: 'attachEditModeChanged',
    value: function attachEditModeChanged() {}
  }, {
    key: 'dettachEditModeChanged',
    value: function dettachEditModeChanged() {}
  }, {
    key: 'getCurrentPageId',
    value: function getCurrentPageId() {
      // Used only in Editor
      return null;
    }
  }, {
    key: 'getSitePages',
    value: function getSitePages() {
      // Used only in Editor & live site
      return null;
    }
  }, {
    key: 'replaceSectionState',
    value: function replaceSectionState() {
      // Used only in Editor & live site
    }
  }, {
    key: 'navigateToPage',
    value: function navigateToPage() {
      // Used only in Editor & live site
    }
  }, {
    key: 'getSiteInfo',
    value: function getSiteInfo() {
      // currently not used in dashboard
      return _promise2.default.resolve({ url: this.baseUrl, baseUrl: this.baseUrl });
    }
  }, {
    key: 'getSectionUrl',
    value: function getSectionUrl(sectionId) {
      var segment = '';
      switch (sectionId) {
        case 'checkout_page':
          segment = 'checkout-page';
          break;
        case 'thank_you_page':
          segment = 'thank-you-page';
          break;

        default:
          break;
      }
      // currently not used in dashboard
      return _promise2.default.resolve({
        url: (0, _urijs2.default)(this.baseUrl).segment(segment)
      });
    }
  }, {
    key: 'getDashboardAppUrl',
    value: function getDashboardAppUrl() {
      // currently not used in dashboard
      return _promise2.default.resolve(_windowWrapper2.default.location.href);
    }
  }, {
    key: 'applicationLoaded',
    value: function applicationLoaded() {
      // TODO
    }
  }, {
    key: 'getLocale',
    value: function getLocale() {
      return this.locale;
    }
  }, {
    key: 'getDeviceType',
    value: function getDeviceType() {
      return 'desktop';
    }
  }, {
    key: 'getBiToken',
    value: function getBiToken() {
      var biToken = '';
      var objInstance = this.getDecodedInstanceObject();
      if (objInstance && objInstance.biToken) {
        biToken = objInstance.biToken;
      }
      return biToken;
    }
  }, {
    key: 'isStyleChanged',
    value: function isStyleChanged() {
      // Irrelevant
      return false;
    }
  }, {
    key: 'isVisualFocusEnabled',
    value: function isVisualFocusEnabled() {
      return _promise2.default.resolve(false);
    }
  }, {
    key: 'getColorByreference',
    value: function getColorByreference() {
      // Irrelevant
      return { value: null };
    }
  }, {
    key: 'getStyleFontByReference',
    value: function getStyleFontByReference() {
      // Irrelevant
      return null;
    }
  }, {
    key: 'getEditorFonts',
    value: function getEditorFonts() {
      // Irrelevant
      return null;
    }
  }]);
  return BizMgrProviderApi;
}();

exports.default = BizMgrProviderApi;